"use strict";

import BaseModelList from "./base-model-list";
import ApiRequest from "@/shared/lib/client-sdk/api-request.js";

class EntityDocumentsList extends BaseModelList {
  constructor(parentModel) {
    super(parentModel);
  }

  getModelClassName() {
    return "EntityDocument";
  }

  getApiPathForSearch() {
    return (
      this.parentModel
        .getApiPathForRefreshUpdateAndDelete()
        .replace("/public/", "/private/") + "/documents"
    );
  }

  getApiPathForAdd() {
    return (
      this.parentModel
        .getApiPathForRefreshUpdateAndDelete()
        .replace("/public/", "/private/") + "/documents"
    );
  }

  getApiPathForRefreshUpdateAndDelete(entityDocument) {
    return entityDocument.getApiPathForRefreshUpdateAndDelete();
  }

  add(document, callback, documentTypeCode) {
    this.currentOperation = "adding";

    var requestUrl = this.getApiPathForAdd();

    let formData = new FormData();
    formData.append("file", document);

    if (documentTypeCode) formData.append("documentType", documentTypeCode);

    ApiRequest.upload(requestUrl, formData).onComplete(
      function (apiResponse) {
        // Refresh even on failure so currentOperation/isAdding gets reset.
        this.refresh(function () {
          if (callback) callback(apiResponse);
        }, "adding");
      }.bind(this)
    );
  }

  // Changes the document type of an already-uploaded document (TECH-12651).
  // Only wired for order-line document lists: the PATCH route is nested under
  // the parent (order line) so the backend can validate membership and log
  // the change against the order line's changelog.
  updateDocumentType(entityDocument, documentTypeCode, callback) {
    var requestUrl = this.getApiPathForSearch() + "/" + entityDocument.id;

    if (!requestUrl.includes("/private/order-lines/"))
      throw new Error(
        "updateDocumentType is only available for order-line documents."
      );

    this.currentOperation = "updating";

    ApiRequest.send("PATCH", requestUrl, {
      documentType: documentTypeCode,
    }).onComplete(
      function (response) {
        if (callback) callback(response);

        this.refresh(null, "updating");
      }.bind(this)
    );
  }
}

export default EntityDocumentsList;
